import styled from "@emotion/styled";


export const BottomFixed = styled.div`
    position: fixed;
    bottom:0;
    left:0;
    right:0;
`;
